export default "/assets/site/images/cluster.svg?fa9fcafe8d2e51d69fc2decb23a0a42e";